import { RefString, Ref } from "@tblabs/truffle";
import { Field } from "./Field";
import { FieldType } from "./FieldType";
import { RawTextWithPictureField } from "./RawTextWithPictureField";


export class TextWithPictureField extends Field
{
    public Type = FieldType.TextWithPicture;
    public Text = new RefString();
    public PictureUrl = new RefString();
    public PicturePosition = new Ref<"left" | "right">("left");

    constructor(raw: Partial<RawTextWithPictureField>)
    {
        super(raw);

        this.Text.value = raw.Text || "";
        this.PictureUrl.value = raw.PictureUrl || "";
        this.PicturePosition.value = raw.PicturePosition || "left";
    }
}
